import { PayloadAction } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';
import orderBy from 'lodash/orderBy';

interface CreateCrudArgs {
  idKey: string;
  itemsKey: string;
  useMap?: boolean;
  mapKey?: string;
  sort?: {
    field: string;
    order: 'asc' | 'desc';
  }
}

export function createCrudActions<ItemType, StateType>({ idKey, itemsKey, sort, useMap, mapKey }: CreateCrudArgs) {
  return {
    onAdd(state: StateType, action: PayloadAction<ItemType>): StateType {
      let items = [
        ...(state as any)[ itemsKey ] as ItemType[],
        action.payload,
      ]

      if (sort) {
        items = orderBy(items, sort.field, sort.order);
      }

      if (useMap && mapKey) {
        return {
          ...state,
          [ itemsKey ]: items,
          [ mapKey ]: keyBy(items, idKey),
        }
      }

      return {
        ...state,
        [ itemsKey ]: items
      }
    },
    onAddMany(state: StateType, action: PayloadAction<ItemType[]>): StateType {
      let items = [
        ...(state as any)[ itemsKey ] as ItemType[],
        ...action.payload,
      ]

      if (sort) {
        items = orderBy(items, sort.field, sort.order);
      }

      if (useMap && mapKey) {
        return {
          ...state,
          [ itemsKey ]: items,
          [ mapKey ]: keyBy(items, idKey),
        }
      }

      return {
        ...state,
        [ itemsKey ]: items
      }
    },
    onUpdate(state: StateType, action: PayloadAction<ItemType>): StateType {
      let items = (state as any)[ itemsKey ].map((item: any) =>
        item[ idKey ] === (action.payload as any)[ idKey ] ? action.payload : item
      );

      if (sort) {
        items = orderBy(items, sort.field, sort.order);
      }

      if (useMap && mapKey) {
        return {
          ...state,
          [ itemsKey ]: items,
          [ mapKey ]: keyBy(items, idKey),
        }
      }

      return {
        ...state,
        [ itemsKey ]: items
      }
    },
    onDelete(state: StateType, action: PayloadAction<ItemType>): StateType {
      const items = (state as any)[ itemsKey ].filter((item: any) => item[ idKey ] !== (action.payload as any)[ idKey ]);

      if (useMap && mapKey) {
        return {
          ...state,
          [ itemsKey ]: items,
          [ mapKey ]: keyBy(items, idKey),
        }
      }

      return {
        ...state,
        [ itemsKey ]: items,
      }
    }
  }
}